<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{pageTitle}}</div>
            </div>
            <div class="detail-content-body-div" style="display: flex; ">
                <div style="width: calc(40% - 18px); margin-right: 36px; display: flex; flex-direction: column;">

                    <div class="order-left" v-if="phaseInfo && phaseInfo.length >0">
                        <div class="item-status" v-for="(item, index) of phaseInfo" :key="index">
                        <div class="status-time" :style="getBorderColor(item, 'color')">{{ item.startTime }}</div>
                            <div class="status-box">
                                <div class="status-radius" :style="getBorderColor(item, 'border')"></div>
                                <div class="status-line"></div>
                            </div>
                            <div class="status-info">
                                <div class="info-status" :style="getBorderColor(item, 'color')">{{ item.phaseStatusName }}</div>
                                <div class="info-remark">{{ item.phaseStatusDesc }}</div>
                                <!-- 用户扫码 -->
                                <el-row class="info-box" v-if="item.phaseStatus === 'SCAN_AND_PAY_SUCCESS' && item.orderPayedPhaseData">
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderPayedPhaseData">
                                    <div class="box-label">用户手机号</div>
                                    <div class="box-value">{{ item.orderPayedPhaseData.userPhone || '--' }}</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderPayedPhaseData">
                                    <div class="box-label">预付金额</div>
                                    <div class="box-value">{{ item.orderPayedPhaseData.prepayAmount || '--' }} 元</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderPayedPhaseData">
                                    <div class="box-label">支付渠道</div>
                                    <div class="box-value">{{ item.orderPayedPhaseData.payModeName || '--' }}</div>
                                    </el-col>
                                </el-row>
                                <!-- 开始充电 -->
                                <el-row class="info-box" v-if="item.phaseStatus === 'ORDER_START_CHARGE' && item.orderStopPhaseData" >
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderStopPhaseData">
                                    <div class="box-label">充电总用时</div>
                                    <div class="box-value">{{ item.orderStopPhaseData.chargeDuration || '--' }}</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderStopPhaseData">
                                    <div class="box-label">充电量</div>
                                    <div class="box-value">{{ item.orderStopPhaseData.totalElec ||  '--' }} kWh</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderStopPhaseData">
                                    <div class="box-label">结束原因</div>
                                    <div class="box-value">{{ item.orderStopPhaseData.stopReason || '--' }}</div>
                                    </el-col>
                                </el-row>
                                <!-- 充电中 -->
                                <el-row class="info-box" v-if="item.phaseStatus === 'ORDER_IN_CHARGE' && item.orderChargingPhaseMonitor" >
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段平均电压</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.avgVoltage ? item.orderChargingPhaseMonitor.avgVoltage.toFixed(2) : '--' }} V</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段平均电流</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.avgCurrent || '--' }} A</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段平均功率</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.avgPower ? item.orderChargingPhaseMonitor.avgPower.toFixed(2) : '--' }} W</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段充电量</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.totalElec || '--' }} kWh</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段用时</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.phaseDuration || '--' }}</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段费用</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.totalFee || '--' }} 元</div>
                                    </el-col>
                                </el-row>
                                <!-- 设备故障 -->
                                <el-row class="info-box" v-if="item.phaseStatus === 'ORDER_IN_ERROR' && item.orderChargingPhaseMonitor" >
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段平均电压</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.avgVoltage ? item.orderChargingPhaseMonitor.avgVoltage.toFixed(2) : '--' }} V</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段平均电流</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.avgCurrent || '--' }} A</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段平均功率</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.avgPower ? item.orderChargingPhaseMonitor.avgPower.toFixed(2) : '--' }} W</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段充电量</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.totalElec || '--' }} kWh</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段用时</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.phaseDuration || '--' }}</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段费用</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.totalFee || '--' }} 元</div>
                                    </el-col>
                                </el-row>
                                <!-- 设备离线 -->
                                <el-row class="info-box" v-if="item.phaseStatus === 'PILE_OFFLINE' && item.orderChargingPhaseMonitor" >
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段平均电压</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.avgVoltage ? item.orderChargingPhaseMonitor.avgVoltage.toFixed(2) : '--' }} V</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段平均电流</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.avgCurrent || '--' }} A</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段平均功率</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.avgPower ? item.orderChargingPhaseMonitor.avgPower.toFixed(2) : '--' }} W</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段充电量</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.totalElec || '--' }} kWh</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段用时</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.phaseDuration || '--' }}</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderChargingPhaseMonitor">
                                    <div class="box-label">阶段费用</div>
                                    <div class="box-value">{{ item.orderChargingPhaseMonitor.totalFee || '--' }} 元</div>
                                    </el-col>
                                </el-row>
                                <!-- 订单完成 -->
                                <el-row class="info-box" v-if="item.phaseStatus === 'ORDER_FINISH' && item.orderRefundedPhaseData">
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderRefundedPhaseData">
                                    <div class="box-label">{{ item.orderRefundedPhaseData.refundResult ? '退款结果' : '退款失败原因'}}</div>
                                        <div class="box-value">
                                        {{ item.orderRefundedPhaseData.refundResult ? '退款成功' : item.orderRefundedPhaseData.refundFailReason }}
                                        </div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderRefundedPhaseData">
                                    <div class="box-label">退款金额</div>
                                    <div class="box-value">{{ item.orderRefundedPhaseData.refundAmount || '--' }} 元</div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" class="box-item" v-if="item.orderRefundedPhaseData">
                                    <div class="box-label">支付渠道</div>
                                    <div class="box-value">{{ item.orderRefundedPhaseData.refundModeName || '--' }}</div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>

                    <div class="order-left" v-else style="font-size: 18px; ">
                        订单流程数据生成中，请内心等待！
                    </div>

                </div>

                <div class="flex detail-form-parent-div" style="width: calc(60% - 18px); flex-wrap: wrap;">
                    <div class="flex-1">
                        <div class="title-div" style="margin-bottom: 24px;">订单信息</div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">订单金额：</div>
                            <div>{{detailForm.tActFee}}&nbsp;&nbsp;元</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">支付方式：</div>
                            <div v-if="detailForm.payMode && detailForm.payMode =='01'">钱包</div>
                            <div v-else-if="detailForm.payMode && detailForm.payMode =='02'">微信</div>
                            <div v-else-if="detailForm.payMode && detailForm.payMode =='03'">代币</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">交易流水号：</div>
                            <div>{{detailForm.payWalletList}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">充电电量：</div>
                            <div>{{detailForm.chargeVal}}&nbsp;&nbsp;kW·h</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">实际收入：</div>
                            <div>{{detailForm.actPayFee}}&nbsp;&nbsp;元</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">平台服务费：</div>
                            <div>{{detailForm.servFee}}&nbsp;&nbsp;元</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">单价：</div>
                            <div>{{detailForm.ttlVal}}&nbsp;&nbsp;元</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">桩到家抵扣：</div>
                            <div v-if="detailForm.deductionWay == '01'">不抵扣</div>
                            <div v-else-if="detailForm.deductionWay == '02'">{{detailForm.deductionElec}}&nbsp;&nbsp;度电</div>
                            <div v-else>-</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">服务商抵扣：</div>
                            <div v-if="detailForm.deductionWay == '01'">不抵扣</div>
                            <div v-else-if="detailForm.deductionWay == '03'">{{detailForm.deductionElec}}&nbsp;&nbsp;度电</div>
                            <div v-else>-</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">实付度电：</div>
                            <div>{{detailForm.needEectric}}&nbsp;&nbsp;度电</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">实付金额：</div>
                            <div>{{detailForm.actPayFee}}&nbsp;&nbsp;元</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">支付状态：</div>
                            <div>{{detailForm.payStatusName}}</div>
                        </div>
                        
                        <div class="title-div" style="margin: 24px 0;">客户信息</div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">客户手机号：</div>
                            <div>{{detailForm.custPhone}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">客户评分：</div>
                            <div v-if="orderReplyEntity">{{orderReplyEntity.custScore}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">客户留言：</div>
                            <div v-if="orderReplyEntity">{{orderReplyEntity.custRemark}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">评价时间：</div>
                            <div v-if="orderReplyEntity">{{orderReplyEntity.custMarkTime}}</div>
                        </div>
                        <div class="title-div" style="margin: 24px 0;">异常订单处理回执</div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">服务费抵扣额：</div>
                            <div v-if="orderReplyEntity">{{orderReplyEntity.freeServiceFee}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">回执：</div>
                            <div>{{detailForm.serviceReceipt}}</div>
                        </div>
                        <!-- <div class="detail-mes-div flex">
                            <div class="detail-title-div">操作人：</div>
                            <div></div>
                        </div> -->
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">操作时间：</div>
                            <div v-if="orderReplyEntity">{{orderReplyEntity.serviceReceiptTime}}</div>
                        </div>
                    </div>
                    <div class="flex-1">
                        <div class="margin-div"></div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">订单编号：</div>
                            <div>{{detailForm.orderNo}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">电桩编号：</div>
                            <div>{{detailForm.pileCode}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">开始时间：</div>
                            <div>{{detailForm.beginTime}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">结束时间：</div>
                            <div>{{detailForm.endTime}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">充电时长：</div>
                            <div>{{detailForm.chargeTime}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">充电站：</div>
                            <div>{{detailForm.stationName}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">紧急停止码：</div>
                            <div>{{detailForm.stopCode}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">订单属性：</div>
                            <div>{{detailForm.orderPropertyName}}</div>
                            <!-- <el-button type="primary" size="small" class="detail-btn" @click="handleOrderDialog">处理</el-button>
                            <el-button type="primary" size="small" class="detail-btn" @click="seeOrderFun">查看</el-button> -->
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">充电状态：</div>
                            <div>{{detailForm.chargeStepName}}</div>
                            <el-button type="primary" size="small" class="detail-btn" @click="toCloseOrder" :disabled="orderFlag">关闭订单</el-button>
                            <!-- <el-button type="primary" size="small" class="detail-btn" @click="toCloseOrder">关闭订单</el-button> -->
                            <el-dialog width="30%" title="" :visible.sync="orderDialogFormVisible">
                                <el-form :model="dialogForm" label-width="100px" ref="dialogForm" :rules="pageConfig.orderFormRules">
                                    <div class="">该操作会直接结束订单</div>
                                    <div class="">如有客户正在充电会强行停止充电</div>
                                    <div class=""></div>
                                    <el-form-item label="关闭原因" prop="chargeOverReason">
                                        <el-input style="width:320px;" size="small" v-model="dialogForm.chargeOverReason" placeholder="请输入关闭原因" maxlength="100"></el-input>
                                    </el-form-item>
                                </el-form>
                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="firstDialogFormVisible = false" size="small">取 消</el-button>
                                    <el-button type="primary" size="small" @click="closeOrder('dialogForm')">确 定</el-button>
                                </div>
                            </el-dialog>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">订单备注：</div>
                            <div v-if="remarkShow">{{detailForm.remark}}</div>
                            <el-input v-if="inputShow" style="width:200px;" size="small" v-model="remark"></el-input>
                            <el-button v-if="btnShow" type="primary" size="small" class="detail-btn" @click="openInput">点击编辑</el-button>
                            <el-button v-if="editShow" type="primary" size="small" class="detail-btn" @click="toEdit()">编辑</el-button>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">关闭原因：</div>
                            <div>{{detailForm.chargeOverReason}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">服务费免征额：</div>
                            <div>{{detailForm.freeServiceFee}}</div>
                        </div>
                    </div>
                    <!-- <el-dialog title="订单详情" :visible.sync="dialogVisible" width="40%">
                        <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" label-width="150px">
                            <div class="flex" v-if="orderStatusFlg">
                                <div class="margin-rt-20">实收金额：&nbsp;{{detailForm.tactFee}}元</div>
                                <div class="margin-rt-20">应收金额：&nbsp;{{detailForm.tactFee}}元</div>
                                <div class="margin-rt-20">充电量：&nbsp;{{detailForm.chargeVal}}Kw·h</div>
                            </div>
                            <div class="flex" v-else>
                                <div class="margin-rt-20">操作人：&nbsp;{{dialogForm.createdByName}}</div>
                                <div class="margin-rt-20">操作时间：&nbsp;{{dialogForm.createdWhen}}</div>
                            </div>
                            <div>
                                <div class="dialog-title-div">APP端处理：</div>
                                <div>
                                    <el-form-item label="是否退款" prop="refundStatus">
                                        <el-radio-group v-model="dialogForm.refundStatus" :disabled="!orderStatusFlg">
                                            <el-radio label="01">不予退款</el-radio>
                                            <el-radio label="02">退款</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="车主回执">
                                        <el-input type="textarea" size='small' v-model="dialogForm.toCustReceipt" :disabled="!orderStatusFlg"></el-input>
                                    </el-form-item>
                                </div>
                                <el-divider></el-divider>
                                <div class="dialog-title-div">SaaS端处理：</div>
                                <div>
                                    <el-form-item label="服务费免征额（元）">
                                        <el-input size='small'  v-model="dialogForm.freeServiceFee" :disabled="!orderStatusFlg"></el-input>
                                    </el-form-item>
                                    <el-form-item label="运营商回执">
                                        <el-input type="textarea" size='small' v-model="dialogForm.serviceReceipt" :disabled="!orderStatusFlg"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button size="small" @click="dialogVisible = false">取 消</el-button>
                            <el-button size="small" type="primary" @click="handleOrderFun" v-if="orderStatusFlg">确 定</el-button>
                        </span>
                    </el-dialog> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig,
                editFlag:false,
                pageTitle:'订单详情',
                // 默认值设置
                detailForm: {},
                dialogForm:{},
                orderReplyEntity:{},
                dialogVisible:false,
                orderStatusFlg:false,
                orderFlag:false,
                remarkShow: true,
                inputShow: false,
                btnShow: true,
                editShow: false,
                remark: '',
                orderDialogFormVisible: false,
                phaseInfo: [],
            }
        },
        methods: {
            init() {
                if(this.$route.query.id){
                    this.editFlag = true;
                    this.getFormInfo();
                }
            },
            // 获取表单信息
            getFormInfo(){
                let _ = this;
                _.$S.getFormInfo(_,_.$A.order.pileorder +'/'+_.$route.query.id,function(res){
                     _.detailForm = res.data.data;
                     _.orderReplyEntity = _.detailForm.orderReplyEntity;
                     if(_.detailForm.chargeStepCode == '02'){
                         _.orderFlag = true;
                     }
                });

                // 流程数据 
                _.$S.getFormInfo(_, `${_.$A.order.orderPhase}${_.$route.query.orderNo}`,(res) => {
                    console.log(res.data.data)
                    _.phaseInfo = res.data.data || [];
                })
            },

            getBorderColor(row, type) {
                // 订单完成 
                if (row.phaseStatus === 'ORDER_FINISH') return type === 'border' ? `${type}: 4px solid #65B85D;` : `${type}: #65B85D;`
                // 用户扫码、充电结束
                if (row.phaseStatus === 'ORDER_STOP_CHARGE' || row.phaseStatus === 'SCAN_AND_PAY_SUCCESS' || row.phaseStatus === 'ORDER_IN_CHARGING_WAIT') return type === 'border' ? `${type}: 4px solid #A9B3C0;` : `${type}: #A9B3C0;`
                // 设备离线
                if (row.phaseStatus === 'PILE_OFFLINE') return type === 'border' ? `${type}: 4px solid #FF6868;` : `${type}: #FF6868;`
                // 设备故障
                if (row.phaseStatus === 'ORDER_IN_ERROR') return type === 'border' ? `${type}: 4px solid #FF9C69;` : `${type}: #FF9C69;`
                // 开始充电、充电中
                if (row.phaseStatus === 'ORDER_START_CHARGE' || row.phaseStatus === 'ORDER_IN_CHARGE') return type === 'border' ? `${type}: 4px solid #5988FD;` : `${type}: #5988FD;`
            },

            handleOrderDialog(){
                this.dialogForm = this.detailForm;
                this.orderStatusFlg = true;
                this.dialogVisible = true;
            },
            seeOrderFun(){
                let _ = this;
                _.dialogForm = _.detailForm.orderReplyEntity;
                this.orderStatusFlg = false;
                this.dialogVisible = true;
            },
            toCloseOrder(){
                this.orderDialogFormVisible = true;
            },
            closeOrder(formName){
                let _ = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var obj = {
                            chargeStepCode:'02',
                            orderNo: _.detailForm.orderNo,
                            chargeOverReason: _.dialogForm.chargeOverReason,
                            id: _.$route.query.id
                        }
                        _.$H.post(_, _.$A.order.updatechargestep, obj).then(res => {
                            _.$U.success("关闭成功");
                            this.orderDialogFormVisible = false;
                            this.detailForm = {};
                            this.getFormInfo();
                        })
                    }
                });
                // if(this.detailForm.chargeStepCode != '02'){
                //     this.$confirm('该操作会直接结束订单，如有客户正在充电则会强行停止充电！是否继续关闭？')
                //     .then(_ => {
                //         this.$H.post(this,this.$A.order.updatechargestep,{chargeStepCode:'02',orderNo:this.detailForm.orderNo}).then(res => {
                //             this.$U.success('关闭成功');
                //             this.detailForm = {};
                //             this.init();
                //         })
                //         done();
                //     })
                //     .catch(_ => {});
                // }else{
                //     this.$U.success('订单已关闭');
                // }
            },
            handleOrderFun(){
                let _ = this;
                _.$H.post(_,_.$A.order.dealorderreply,_.dialogForm).then(res => {
                    _.dialogVisible = false
                    _.detailForm = {};
                    _.init();
                })
            },
            openInput(){
                this.btnShow = false;
                this.editShow = true;
                this.remarkShow = false;
                this.inputShow = true;
                this.detailForm.remark = '';
            },
            toEdit(){
                let _ = this;
                _.$U.showLoading(_);
                var obj = {};
                obj.id = _.$route.query.id;
                obj.remark = _.remark;
                _.$H.post(_, _.$A.order.updateRemark, obj).then(res => {
                    _.$U.success("编辑成功")
                    _.btnShow = true;
                    _.editShow = false;
                    _.remarkShow = true;
                    _.inputShow = false;
                    _.getFormInfo();
                    _.$U.hideLoading(_);
                })
            },
        },
        mounted() {
            this.init();
        }
    }
</script>

<style lang="less" scoped>
.detail-mes-div{
    height:35px;
    line-height: 35px;
    padding:10px;
    margin-bottom: 10px;
    font-size:14px;
}
.detail-title-div{
    width:150px;
    text-align: right;
    margin-right:50px;
}
.detail-btn{
    height:32px;
    margin-left: 45px;
}
.margin-rt-20{
    margin-right:20px;
}
.dialog-title-div{
    margin:15px 0px;
}
.margin-div{
    margin-top:38px;
}
.title-div{
    font-size:15px;
    font-weight: 800;
    margin-top:15px;
}
.order-left {
  width: 100%;
  height: 100%;
  display: flex; 
  flex-direction: column; 

  .item-status {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: stretch;
    justify-content: flex-start;

    font-family: 'SourceHanSansCN', 'Source Han Sans CN', sans-serif;
    font-weight: bolder;
    font-size: 14px;
    color: #86909C;
    line-height: 24px;
    text-align: left;
    font-style: normal;

    .status-time {
      width: 140px;
      margin-right: 12px;
    }

    .status-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 20px;
      margin-top: 5px;

      .status-radius {
        width: 16px;
        height: 16px;
        border-radius: 8px;
      }

      .status-line {
        width: 2px;
        height: calc(100% - 16px);
        background: #F2F2F2;
      }
    }
        
    .status-info {
      width: calc(100% - 16px - 20px - 12px - 140px);
      height: 100%;
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;

      .info-status {
        margin-bottom: 12px;
      }

      .info-remark {
        font-family: 'SourceHanSansCN', 'Source Han Sans CN', sans-serif;
        font-weight: 400;
        font-size: 14px;
        color: #A9B3C0;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        margin-bottom: 16px;
      }
            
      .info-box {
        padding: 16px 16px 0 16px;
        box-sizing: border-box;

        background: #FBFCFF;
        border-radius: 8px;
        border: 1px solid #F2F2F2;

        .box-item {
          text-align: center;
          margin-bottom: 16px;

          .box-label {
            font-family: 'SourceHanSansCN', 'Source Han Sans CN', sans-serif;
            font-weight: 400;
            font-size: 12px;
            color: #757E9B;
            line-height: 18px;
            text-align: center;
            font-style: normal;

            margin-bottom: 12px;
          }
          .box-value {
            font-family: 'SourceHanSansCN', 'Source Han Sans CN', sans-serif;
            font-weight: bolder;
            font-size: 12px;
            color: #364166;
            line-height: 18px;
            text-align: center;
            font-style: normal;
          }
        }

      }

    }

  }

  .item-status:last-child {

    .status-box {

      .status-line {
        display: none;
        }

    }

  }
}
</style>
